/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ConfigRouteIds {
    SomeRoute = 'SomeRoute',
}
